// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a8622e9c","821":"87ca55f4"}[chunkId] + ".chunk.js";
};